export const COMPANY_NAME_CR = 'ChaletRetreat'
export const COMPANY_NAME_MC = 'MonsieurChalets'
